@if (errorMessage) {
  <tidy-error-message [text]="errorMessage" />
}

@if (windowService?.isDesktopRes) {
  <tidy-desktop-header #upsellsHeader>
    <div class="wrappable-container">
      <tidy-text [header]="'Upsells'" />
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search"
          [showClearButton]="true"
          (clear)="clearSearch()" />
      </form>
      <tidy-small-button
        [text]="'Upsell Settings'"
        [image]="'assets/img/settings-white.svg'"
        (buttonClick)="openUpsellSettings()" />
      <tidy-small-button
        [text]="'Integrate'"
        [image]="'assets/img/link-white.svg'"
        (buttonClick)="openIntegrationInfo()" />
      <tidy-small-button
        [text]="'Add Upsell'"
        [image]="'assets/img/add-button-white.svg'"
        (buttonClick)="goToAddUpsellPage()" />
      <tidy-image
        [src]="'assets/img/download_csv.svg'"
        class="desktop-header-icon secondary-text-icon"
        (action)="exportCSV()" />
    </div>
    <div class="non-wrappable-right-aligned-container">
      @if (showLoadingSpinner) {
        <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px" />
      }
      <automations-preview-button
        [tag]="'upsells'" />
    </div>
  </tidy-desktop-header>
}

<!-- Skeleton table while loading — rows float in with the entrance cascade;
     the real table below then replaces it in place, instantly (skipEntrance). -->
@if (!loaded && windowService?.isDesktopRes) {
  <tidy-table
    [skeletonLoading]="true"
    [columnslabels]="headers" />
}

@if (loaded && windowService?.isDesktopRes) {
  <tidy-table
    [dataSource]="rows"
    [displayedColumns]="headers"
    [columnslabels]="headers"
    [showColumnLines]="false"
    [rowsToShow]="50"
    [allRowIsClickable]="true"
    [skipEntrance]="true"
    (sortChange)="sortChanged($event)"
    (cellClick)="onTableColumnClick($event)"
    [infiniteScroll]="true"
    [totalRows]="rows.length"
    (pageChange)="onPageChange()" />
}

@if (!windowService?.isDesktopRes && loaded) {
  <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 10px;">
    <div style="flex: 1; min-width: 0;">
      <form [formGroup]="searchForm" novalidate action="#">
        <tidy-search-input
          formControlName="search"
          [placeholder]="'Search'"
          [icon]="'assets/img/search-header.svg'"
          class="header-search"
          [showClearButton]="true"
          (clear)="clearSearch()" />
      </form>
    </div>
    <tidy-small-button [iconOnly]="true" [image]="'assets/img/settings-white.svg'" (buttonClick)="openUpsellSettings()" />
    <tidy-small-button [iconOnly]="true" [image]="'assets/img/link-white.svg'" (buttonClick)="openIntegrationInfo()" />
    <tidy-small-button [iconOnly]="true" [image]="'assets/img/add-button-white.svg'" (buttonClick)="goToAddUpsellPage()" />
  </div>
  @for (row of rows; track $index) {
    <tidy-card>
      <tidy-card-button (action)="onTableColumnClick(row)" class="arrow-to-top">
        <tidy-row class="vertical-align-center">
          <ion-icon name="home" [style.color]="row['Property'].color || '#1E2125'" style="font-size: 16px; margin-right: 4px;" />
          <tidy-text [header]="row['Property'].value" [translate]="false" />
        </tidy-row>
        <tidy-row>
          <tidy-text [helper]="row['Reservation'].value" [translate]="false" />
        </tidy-row>
        <tidy-row>
          <tidy-text [body]="row['Request'].value" [translate]="false" />
        </tidy-row>
      </tidy-card-button>
    </tidy-card>
  }
  @if (rows.length === 0) {
    <tidy-alert>
      <tidy-row>
        <tidy-text [body]="'No upsells found.'" />
      </tidy-row>
    </tidy-alert>
  }
}

@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'upsells'" [overlayTop]="overlayTop" (dismissed)="dismissAboutThisPage()" />
}
